import type { ReactNode } from 'react'
import { FloatingDelayGroup } from '@floating-ui/react'
import { TooltipGroupContext } from '#hooks/use-tooltip.ts'

export interface TooltipGroupProps {
  /** Milliseconds a hover must dwell before the first tooltip opens. */
  openDelay?: number
  closeDelay?: number
  /** How long the pointer may be away before the next tooltip waits for `openDelay` again. */
  timeoutMs?: number
  children: ReactNode
}

/** Once one tooltip inside has opened, moving to the next opens it at once. */
export function TooltipGroup({ openDelay = 500, closeDelay = 100, timeoutMs = 400, children }: TooltipGroupProps) {
  return (
    <FloatingDelayGroup delay={{ open: openDelay, close: closeDelay }} timeoutMs={timeoutMs}>
      <TooltipGroupContext value={true}>{children}</TooltipGroupContext>
    </FloatingDelayGroup>
  )
}

export default TooltipGroup
